export default "/assets/images/girl.7c03ebe5e9c8df90.jpg";